'use client'

import { useEffect } from 'react'

// Root-level error boundary. `error.jsx` only catches throws inside the route subtree — an error
// thrown by the ROOT LAYOUT itself (e.g. a context provider crashing during render, or a blocked
// storage read in a provider mounted in layout.jsx) escapes it. `global-error` is the last line
// of defence: it replaces the whole document, so it must render its own <html>/<body>. Styles are
// inline because the app's stylesheet may not have loaded when this renders.
export default function GlobalError({ error, reset }) {
  useEffect(() => {
    console.error('Global error boundary caught:', error)
  }, [error])

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#0f0f14',
          color: '#ffffff',
          fontFamily:
            'system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
          padding: '24px',
          textAlign: 'center',
          gap: '18px',
        }}
      >
        <h2 style={{ fontSize: '20px', fontWeight: 700, margin: 0 }}>
          Something went wrong
        </h2>
        <p
          style={{
            maxWidth: '420px',
            opacity: 0.8,
            fontSize: '15px',
            margin: 0,
          }}
        >
          We hit an unexpected error. Try again, or reload the page.
        </p>
        <p
          style={{
            maxWidth: '420px',
            opacity: 0.55,
            fontSize: '13px',
            margin: 0,
          }}
        >
          If it keeps happening, a browser extension or blocked site storage may
          be interfering — try a normal window with your usual privacy settings.
        </p>
        <button
          onClick={() => reset()}
          style={{
            background: '#7a74eb',
            color: '#ffffff',
            border: 'none',
            borderRadius: '9999px',
            padding: '10px 24px',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
        <button
          onClick={() => {
            if (typeof window !== 'undefined') window.location.reload()
          }}
          style={{
            background: 'transparent',
            color: '#7a74eb',
            border: 'none',
            fontSize: '14px',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          Reload the page
        </button>
      </body>
    </html>
  )
}
